import {Component} from "@angular/core";
import {WorkflowService} from "./workflow.service";
import {get} from "lodash";
import {WorkflowStepGqlModel} from "./models/workflow.gql-model";
import {WorkflowStepStatus} from "./models/workflow-step-status.enum";

@Component({
  selector: "workflow-blocked-notice",
  templateUrl: "./workflow-blocked-notice.template.pug",
})
export class WorkflowBlockedNoticeComponent {
  thisStepIsBlocked: boolean = false;
  nextStep: WorkflowStepGqlModel;

  constructor(private workflowService: WorkflowService) {
    this.workflowService.workflowStatus.subscribe(() => {
      this.check();
    });

    this.workflowService.workflowStepStatus.subscribe(() => {
      this.check();
    });
  }

  check() {
    const thisStepName = get(this.workflowService.currentStep, "stepName");
    const thisStepStatus = get(this.workflowService, "currentStep.status");
    const previousStepNeedsWork = get(this.workflowService, "currentStep.previousStepNeedsWork", false) as boolean;

    if (previousStepNeedsWork) {
      for (const step of this.workflowService.workflowConfig.steps) {
        if (step.stepName === thisStepName) {
          break;
        }

        if (step.status !== WorkflowStepStatus.Completed) {
          this.nextStep = step;
          break;
        }
      }
    }

    this.thisStepIsBlocked = thisStepStatus === WorkflowStepStatus.Blocked && !previousStepNeedsWork;
  }
}
